// extracted by mini-css-extract-plugin
export var title = "General-module--title--1uEhc";
export var subtitle = "General-module--subtitle--2crDe";
export var wrapperdescription = "General-module--wrapperdescription--749H5";
export var description = "General-module--description--yErhf";
export var links = "General-module--links--aHOaf";
export var wrapperForm = "General-module--wrapperForm--1JArO";
export var select = "General-module--select--pI4yK";
export var wrapperSocialNetwork = "General-module--wrapperSocialNetwork--EkxFk";
export var link = "General-module--link--1R0-_";
export var img = "General-module--img--2Mo2A";